import React, { Component } from "react";
import moment from "moment";
import "../../main.scss";
import "./batchtile.scss";
import Footer from "../../components/lib/footer/footer";
import { apiCall } from "../../utils/restclient";
import {
  getUserFriendlyErrorMessage,
  DEFAULT,
  INCORRECT_FILE_TYPE,
  FILE_TOO_LARGE,
} from "../../utils/errormessages";
import Loader from "../../components/lib/loader/loader";
import uploadFile from "../../components/images/upload-file.png";
import uploadFileBlue from "../../components/images/upload-selected.png";
import rotateIcon from "../../components/images/rotate.png";
import downloadIcon from "../../components/images/download.png";
import alertIcon from "../../components/images/alert.png";
import rotateIconDisabled from "../../components/images/rotate-disabled.png";
import downloadIconDisabled from "../../components/images/download-disabled.png";
import alertIconDisabled from "../../components/images/alert-disabled.png";
import closeIcon from "../../components/images/close-tile.png";
import { isSafari } from "react-device-detect";
import SimpleBar from "simplebar-react";
import dsLogo from "../../components/images/donorsearch_logo.png";
import { checkVersion } from "../../utils/buildinfo";
import { Helmet } from "react-helmet";

let download = require("downloadjs");
const MAX_FILE_SIZE = 26214400;
class BatchTile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      files: [],
      fileToUpload: null,
      dragging: false,
      isPending: false,
      organizationId: null,
      updating: false,
      needNewUpdate: false,
      loading: false,
      showErrorModal: false,
      recordErrors: [],
      generalErrorCode: null,
      showErrorMessage: false,
      errorMessage: "",
      errorFile: null,
      token: null,
    };
    this.dragCounter = 0;
    this.currentTimeOut = null;
    this.fileInputElement = null;
  }
  _getToken(callback = null) {
    let token = window.localStorage.getItem("jwt");
    if (token != null) {
      this.state.token = token;
      this._getFilesList();

      return;
    }
    let authUrl = "v1/auth";
    let SecretKey = window.location.href.split("?")[0].split("/")[
      window.location.href.split("?")[0].split("/").length - 1
    ];
    let params = new URLSearchParams(window.location.search);
    let OrganizationName = params.get("orgname");
    let authBody = { OrganizationName, SecretKey };
    apiCall(authUrl, "POST", null, JSON.stringify(authBody))
      .then((authResponse) => {
        this.state.token = authResponse.JwtAccessToken;
        window.localStorage.setItem(`jwt`, authResponse.JwtAccessToken);
        if (callback) {
          callback();
          return;
        }
        this._getFilesList();
      })
      .catch((error) => {
        if (error.ErrorCode) {
          this.setState({
            errorMessage: getUserFriendlyErrorMessage(
              error.UserFriendlyErrorCode
            ),
            showErrorMessage: true,
            loading: false,
            updating: false,
          });
        } else {
          this.setState({
            errorMessage: getUserFriendlyErrorMessage(DEFAULT),
            showErrorMessage: true,
            loading: false,
            updating: false,
          });
        }
      });
  }
  _displayDSLogo() {
    return <img src={dsLogo} alt={"logo"} className="ds-logo" />;
  }
  _displayErrorMessage() {
    if (this.state.showErrorMessage) {
      return (
        <div className="main-error-container">
          <text className="main-error">{this.state.errorMessage}</text>
        </div>
      );
    }
  }
  _downloadErrorFile() {
    let blobUrl = `v1/batchfiles/${this.state.errorFile.FileId}/errors/download	`;
    apiCall(
      blobUrl,
      "GET",
      { Authorization: `Bearer ${this.state.token}` },
      null,
      null,
      null,
      0,
      true
    )
      .then((blob) => {
        download(
          blob,
          this.state.errorFile.DisplayName + " Error Report.csv",
          ""
        );
      })
      .catch((error) => {
        if (error.ErrorCode) {
          if (error.ErrorCode === "Unauthorized") {
            this.state.token = null;
            window.localStorage.removeItem("jwt");
            this._getToken(() => {
              this._downloadErrorFile();
            });
            return;
          }
          this.setState({
            errorMessage: getUserFriendlyErrorMessage(
              error.UserFriendlyErrorCode
            ),
            showErrorMessage: true,
          });
        } else {
          this.setState({
            errorMessage: getUserFriendlyErrorMessage(DEFAULT),
            showErrorMessage: true,
            loading: false,
          });
        }
      });
  }
  _downloadFile(file) {
    let blobUrl = `v1/batchfiles/${file.FileId}/download`;
    this.setState({ showErrorMessage: false });
    apiCall(
      blobUrl,
      "GET",
      { Authorization: `Bearer ${this.state.token}` },
      null,
      null,
      null,
      0,
      true
    )
      .then((blob) => {
        download(blob, file.DisplayName);
      })
      .catch((error) => {
        if (error.ErrorCode) {
          if (error.ErrorCode === "Unauthorized") {
            this.state.token = null;
            window.localStorage.removeItem("jwt");
            this._getToken(() => {
              this._downloadFile(file);
            });
            return;
          }
          this.setState({
            errorMessage: getUserFriendlyErrorMessage(
              error.UserFriendlyErrorCode,
              null,
              file.DisplayName
            ),
            showErrorMessage: true,
          });
        } else {
          this.setState({
            errorMessage: getUserFriendlyErrorMessage(DEFAULT),
            showErrorMessage: true,
            loading: false,
          });
        }
      });
  }
  _displayFile(file, index) {
    return (
      <div className="file-container">
        <div class="file-name-container">
          <label className="file-name">{file.DisplayName}</label>
        </div>

        <div className="file-info-container">
          <label className="file-date">
            {file.FinishProcessingDateTime
              ? moment(file.FinishProcessingDateTime).format("M/D/YYYY")
              : `${file.CountProcessedRecords} of  ${file.CountRecords} record${
                  file.CountRecords > 1 ? "s" : ""
                }`}
          </label>
          {file.FinishProcessingDateTime == null ? (
            <img
              className="rotate-icon-disabled"
              src={rotateIconDisabled}
              alt={`File ${index} refresh button. Disabled.`}
            />
          ) : (
            <img
              className="rotate-icon"
              src={rotateIcon}
              alt={`File ${index} refresh button`}
              onClick={() => {
                this._rerunFile(file);
              }}
            />
          )}
          <img
            className="download-icon"
            src={downloadIcon}
            alt={`${file.DisplayName} download button`}
            onClick={() => {
              this._downloadFile(file);
            }}
          />
          <img
            style={{ color: "red" }}
            className="alert-icon"
            onClick={() => {
              if (!file.HasErrors) return;
              this._getErrors(file);
            }}
            disabled={file.HasErrors ? false : true}
            src={file.HasErrors ? alertIcon : alertIconDisabled}
            alt={`File ${index} alert button`}
          />
        </div>
      </div>
    );
  }
  _getErrors = (file) => {
    let errorsUrl = `v1/batchfiles/${file.FileId}/errors`;
    this.setState({ loading: true, showErrorMessage: false });
    apiCall(errorsUrl, "GET", { Authorization: `Bearer ${this.state.token}` })
      .then((errorResponse) => {
        this.setState({
          showErrorModal: true,
          generalErrorCode: errorResponse.UserFriendlyErrorCode,
          recordErrors: errorResponse.RecordErrors,
          loading: false,
          errorFile: file,
        });
      })
      .catch((error) => {
        if (error.ErrorCode === "Unauthorized") {
          this.state.token = null;
          window.localStorage.removeItem("jwt");
          this._getToken(() => {
            this._getErrors(file);
          });
          return;
        }
        this.setState({
          loading: false,
          showErrorMessage: true,
          errorMessage: getUserFriendlyErrorMessage(
            error.UserFriendlyErrorCode,
            null,
            file.DisplayName
          ),
        });
      });
  };
  _getFilesList = () => {
    let listUrl = `v1/batchfiles`;
    apiCall(listUrl, "GET", { Authorization: `Bearer ${this.state.token}` })
      .then((response) => {
        response.Files.sort((a, b) => {
          if (
            a.FinishProcessingDateTime == null &&
            b.FinishProcessingDateTime == null
          ) {
            if (a.DisplayName.toLowerCase() < b.DisplayName.toLowerCase()) {
              return -1;
            }
            if (a.DisplayName.toLowerCase() > b.DisplayName.toLowerCase()) {
              return 1;
            }
            return 0;
          } else if (a.FinishProcessingDateTime == null) {
            return -1;
          } else if (b.FinishProcessingDateTime == null) {
            return 1;
          }
          if (
            moment(a.FinishProcessingDateTime).isAfter(
              moment(b.FinishProcessingDateTime)
            )
          ) {
            return -1;
          } else if (
            moment(a.FinishProcessingDateTime).isBefore(
              moment(b.FinishProcessingDateTime)
            )
          ) {
            return 1;
          } else {
            if (a.DisplayName.toLowerCase() < b.DisplayName.toLowerCase()) {
              return -1;
            }
            if (a.DisplayName.toLowerCase() > b.DisplayName.toLowerCase()) {
              return 1;
            }
            return 0;
          }
        });
        let needNewUpdate = false;
        for (let i = 0; i < response.Files.length; i++) {
          if (response.Files[i].FinishProcessingDateTime == null) {
            i = response.Files.length;
            needNewUpdate = true;
            this.setState({ needNewUpdate });
            if (this.currentTimeOut == null) {
              this.currentTimeOut = setTimeout(() => {
                this.currentTimeOut = null;
                this._getFilesList();
              }, 5000);
            }
          }
        }
        if (!needNewUpdate && this.state.needNewUpdate) {
          this.currentTimeOut = null;
          this.setState({ needNewUpdate: false, loading: true });
          setTimeout(() => {
            this.setState({ loading: false });
            setTimeout(() => {
              this._setDropEventListeners();
            }, 1000);
          }, 500);
        }
        this.setState({
          files: response.Files,
        });
      })
      .catch((error) => {
        if (error.ErrorCode === "Unauthorized") {
          this.state.token = null;
          window.localStorage.removeItem("jwt");
          this._getToken(() => {
            this._getFilesList();
          });
          return;
        }
        if (error.UserFriendlyErrorCode) {
          this.setState({
            loading: false,
            showErrorMessage: true,
            errorMessage: getUserFriendlyErrorMessage(
              error.UserFriendlyErrorCode
            ),
          });
        } else {
          this.setState({
            loading: false,
            showErrorMessage: true,
            errorMessage: getUserFriendlyErrorMessage(DEFAULT),
          });
        }
      });
  };
  _handleDrag = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };
  _handleDragIn = (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.dragCounter++;
    if (e.dataTransfer.items && e.dataTransfer.items.length > 0) {
      this.setState({ dragging: true });
    }
  };
  _handleDragOut = (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.dragCounter--;
    if (this.dragCounter === 0) {
      this.setState({ dragging: false });
    }
  };
  _handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.setState({ dragging: false, showErrorMessage: false });
    let ext = e.dataTransfer.files[0].name.split(".").pop();
    let size = e.dataTransfer.files[0].size;
    if (
      e.dataTransfer.files &&
      e.dataTransfer.files.length > 0 &&
      this.state.fileToUpload == null &&
      size <= MAX_FILE_SIZE &&
      (ext === "xlsx" || ext === "xls")
    ) {
      this._onDragFileSelected(e.dataTransfer.files[0]);
      e.dataTransfer.clearData();
      this.dragCounter = 0;
    }

    if (size > MAX_FILE_SIZE) {
      this.setState({
        showErrorMessage: true,
        errorMessage: getUserFriendlyErrorMessage(FILE_TOO_LARGE),
      });
      return;
    }

    if (ext !== "xlsx" && ext !== "xls") {
      let name = e.dataTransfer.files[0].name.split(".").slice(0, -1).join(".");
      this.setState({
        showErrorMessage: true,
        errorMessage: getUserFriendlyErrorMessage(
          INCORRECT_FILE_TYPE,
          null,
          name
        ),
      });
    }
  };
  _onDragFileSelected = (file) => {
    let fileToUpload = file;
    this.setState({ fileToUpload });
  };
  _onFileSelected = (event) => {
    let fileToUpload = event.target.files[0];
    let size = fileToUpload.size;
    if (size > MAX_FILE_SIZE) {
      this.setState({
        showErrorMessage: true,
        errorMessage: getUserFriendlyErrorMessage(FILE_TOO_LARGE),
      });
      return;
    }
    this.setState({ fileToUpload, showErrorMessage: false });
    event.target.value = "";
  };
  _rerunFile(file) {
    let blobUrl = `v1/batchfiles/${file.FileId}/rerun`;
    this.setState({ showErrorMessage: false });
    apiCall(
      blobUrl,
      "PUT",
      { Authorization: `Bearer ${this.state.token}` },
      null,
      null,
      null,
      0,
      true
    )
      .then((blob) => {
        this._getFilesList();
      })
      .catch((error) => {
        if (error.ErrorCode) {
          if (error.ErrorCode === "Unauthorized") {
            this.state.token = null;
            window.localStorage.removeItem("jwt");
            this._getToken(() => {
              this._rerunFile(file);
            });
            return;
          }
          this.setState({
            errorMessage: getUserFriendlyErrorMessage(
              error.UserFriendlyErrorCode,
              null,
              file.DisplayName
            ),
            showErrorMessage: true,
          });
        } else {
          this.setState({
            errorMessage: getUserFriendlyErrorMessage(DEFAULT),
            showErrorMessage: true,
            loading: false,
          });
        }
      });
  }
  _setDropEventListeners() {
    let div = document.getElementById("dropbox");
    if (div == null) return;
    div.addEventListener("dragenter", this._handleDragIn);
    div.addEventListener("dragleave", this._handleDragOut);
    div.addEventListener("dragover", this._handleDrag);
    div.addEventListener("drop", this._handleDrop);
  }
  _showErrorModal() {
    return (
      <div className="error-modal-container">
        <div className="error-view">
          <div className="error-title-container">
            <div className="right-title-error">
              <label className="record-errors">Record Errors</label>
            </div>
            <div className="left-title-error">
              <div
                className="full-error-btn"
                onClick={() => {
                  this._downloadErrorFile();
                }}
              >
                <img
                  id="download-error-btn"
                  className="error-download-icon"
                  src={downloadIcon}
                  alt={`$Error report download button`}
                />
                <label className="download-error-report">
                  Download Error Report
                </label>
              </div>
              <img
                className="close-error"
                src={closeIcon}
                alt="close-error"
                onClick={() => {
                  this.setState({ showErrorModal: false });
                }}
              />
            </div>
          </div>
          <div className="error-list">
            {this.state.generalErrorCode ? (
              <div className="error-label-container">
                <label className="error-label-right">
                  Error Code: {this.state.generalErrorCode} -
                </label>
                &nbsp;
                <label className="error-label">
                  {getUserFriendlyErrorMessage(
                    this.state.generalErrorCode,
                    null,
                    null,
                    true
                  )}
                </label>
              </div>
            ) : (
              this.state.recordErrors.map((error) => {
                return (
                  <div className="error-label-container">
                    <label className="error-label-right">
                      Error Code: {error.UserFriendlyErrorCode} - Primary ID:{" "}
                      {error.Value} -
                    </label>
                    &nbsp;
                    <label className="error-label">
                      {getUserFriendlyErrorMessage(
                        error.UserFriendlyErrorCode,
                        null,
                        error.Value,
                        true
                      )}
                    </label>
                  </div>
                );
              })
            )}
          </div>
        </div>
      </div>
    );
  }
  _uploadFile = () => {
    this.setState({ updating: true, showErrorMessage: false });
    let name = this.state.fileToUpload.name.split(".").slice(0, -1).join(".");

    let uploadUrl = `v1/batchfiles`;
    let body = new FormData();
    // body.append("OrganizationId", this.state.organizationId);
    body.append("File", this.state.fileToUpload);
    apiCall(
      uploadUrl,
      "POST",
      { Authorization: `Bearer ${this.state.token}` },
      body,
      null,
      {}
    )
      .then((response) => {
        this.setState({ fileToUpload: null, updating: false });
        setTimeout(() => {
          this._setDropEventListeners();
        }, 1000);
        this._getFilesList();
      })
      .catch((error) => {
        if (error.ErrorCode === "Unauthorized") {
          this.state.token = null;
          window.localStorage.removeItem("jwt");
          this._getToken(() => {
            this._uploadFile();
          });
          return;
        }
        if (error.UserFriendlyErrorCode) {
          this.setState({
            loading: false,
            showErrorMessage: true,
            errorMessage: getUserFriendlyErrorMessage(
              error.UserFriendlyErrorCode,
              null,
              name
            ),
          });
        } else {
          this.setState({
            loading: false,
            showErrorMessage: true,
            errorMessage: getUserFriendlyErrorMessage(DEFAULT),
          });
        }
        this.setState({ fileToUpload: null, updating: false });
      });
  };

  componentDidMount() {
    checkVersion().then((result) => {
      if (result) {
        let link =
          window.location.href.split("batchtile")[0] +
          `batchtile/${result}` +
          window.location.href.split("batchtile")[1];
        window.location.href = link;
      }
    });

    let div = document.getElementById("dropbox");
    this._getToken();
    if (div === null) return;
    div.addEventListener("dragenter", this._handleDragIn);
    div.addEventListener("dragleave", this._handleDragOut);
    div.addEventListener("dragover", this._handleDrag);
    div.addEventListener("drop", this._handleDrop);
  }
  componentWillUnmount() {
    let div = document.getElementById("dropbox");
    if (div === null) return;
    div.removeEventListener("dragenter", this._handleDragIn);
    div.removeEventListener("dragleave", this._handleDragOut);
    div.removeEventListener("dragover", this._handleDrag);
    div.removeEventListener("drop", this._handleDrop);
  }
  render() {
    let inputButtonClasses = "input-button main-button";
    if (isSafari) {
      inputButtonClasses = "isSafari input-button main-button";
    }
    return (
      <body
        style={{
          display: "block",
          height: 360,
          width: "100%",
          minWidth: 1200,
          backgroundColor: "white",
          flex: 1,
        }}
      >
        <Helmet>
          <meta http-equiv="cache-control" content="no-cache" />
          <meta http-equiv="expires" content="0" />
          <meta http-equiv="pragma" content="no-cache" />
        </Helmet>
        {this.state.showErrorModal ? this._showErrorModal() : null}
        <div className="title-container">
          <label className="title">DonorSearch Batch Update</label>
        </div>

        <div className="view-container">
          <div className="batch-container">
            <div
              className="drag-drop-container center-horizontal"
              style={{
                marginTop: 67,
                borderColor: this.state.fileToUpload ? "#41C2CC" : null,
                maxWidth: this.state.fileToUpload ? null : null,
              }}
            >
              <div
                className="drop-box"
                id="dropbox"
                ref={this.dropRef}
                style={{
                  borderColor: this.state.fileToUpload ? "#41C2CC" : null,
                }}
              >
                <img
                  className="file-icon"
                  src={this.state.fileToUpload ? uploadFileBlue : uploadFile}
                  alt="upload file"
                />
                <span className="drag-label-container" style={{}}>
                  <label
                    className="drag-drop-label"
                    style={{
                      color: this.state.fileToUpload ? "#333333" : null,
                      overflow: "hidden",
                    }}
                  >
                    {this.state.fileToUpload
                      ? this.state.fileToUpload.name
                          .split(".")
                          .slice(0, -1)
                          .join(".")
                      : "Drag and Drop files here"}
                  </label>
                  {this.state.fileToUpload ? (
                    <img
                      className="clear-button"
                      src={closeIcon}
                      alt="Clear file selection"
                      onClick={() => {
                        this.setState({ fileToUpload: null });
                      }}
                    />
                  ) : null}
                </span>

                <label
                  for={this.state.fileToUpload ? null : "file-upload"}
                  className={inputButtonClasses}
                  style={{
                    backgroundColor: this.state.fileToUpload ? "#41C2CC" : null,
                    borderColor: this.state.fileToUpload ? "#41C2CC" : null,
                    color: this.state.fileToUpload ? "white" : null,
                  }}
                  onClick={
                    this.state.fileToUpload == null
                      ? null
                      : () => {
                          this._uploadFile();
                        }
                  }
                >
                  {this.state.fileToUpload ? "Update File" : "Choose File"}
                </label>
                <input
                  id="file-upload"
                  accept=".xls,.xlsx"
                  className="input-button"
                  type="file"
                  name="file"
                  onChange={this._onFileSelected}
                  title="Choose File"
                />
              </div>
            </div>
            {this._displayErrorMessage()}
            {this._displayDSLogo()}
          </div>
          <div className="history-container">
            <div className="column-title-container">
              <label className="history-title">File Name</label>
              <label className="history-title">Date</label>
            </div>
            <SimpleBar
              style={{
                minHeight: 100,
                maxHeight: 250,
                flex: 1,
                display: "flex",
                width: "100%",
              }}
            >
              {this.state.files.map((file, index) =>
                this._displayFile(file, index)
              )}
            </SimpleBar>
          </div>
          {this.state.updating || this.state.loading ? (
            <div
              style={{
                position: "absolute",
                width: "100%",
                height: 320,
                backgroundColor: "white",
              }}
            >
              <Loader
                message={this.state.updating ? "Updating..." : "Loading..."}
              />
            </div>
          ) : null}
        </div>
        <Footer />
      </body>
    );
  }
}
export default BatchTile;
